import { render, staticRenderFns } from "./DefectDefinitionForm.vue?vue&type=template&id=dce7a020&"
import script from "./DefectDefinitionForm.vue?vue&type=script&lang=js&"
export * from "./DefectDefinitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports